module.exports = {"130425100":"大名镇","130425101":"杨桥镇","130425102":"万堤镇","130425103":"龙王庙镇","130425104":"束馆镇","130425105":"金滩镇","130425106":"沙圪塔镇","130425107":"大街镇","130425201":"王村乡","130425202":"铺上乡","130425203":"黄金堤乡","130425205":"旧治乡","130425206":"西未庄乡","130425207":"孙甘店乡","130425208":"西付集乡","130425209":"埝头乡","130425210":"北峰乡","130425211":"张铁集乡","130425212":"红庙乡","130425213":"营镇回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130425.json
// module id = 106
// module chunks = 0